var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnooBoxInactiveV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "58px",
    height: "31px",
    viewBox: "0 0 58 31",
    style: {
      enableBackground: "new 0 0 58 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#8C8C8C;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#9F9F9F;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#B3B3B3;}\n\t.st3{fill:none;stroke:#4D596B;stroke-width:0.5;stroke-linecap:round;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snoo_rental"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_acc_overview_order_placed",
    transform: "translate(-457.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(191.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(237.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(30.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "55.5,23.9 46.8,28.9 47.2,5.2 55.9,2.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "st1",
    points: "46.8,28.8 0.2,23.3 0.2,2 47.2,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "st2",
    points: "47.2,5.2 0.1,2.1 12.7,0.2 55.9,2.9  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.022437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-4",
    className: "st3",
    d: "M0.1,2L43.7,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-6",
    className: "st3",
    d: "M12.7,0.1l43.3,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-8",
    className: "st3",
    d: "M0.1,23.3l46.6,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-10",
    className: "st3",
    d: "M0.1,2v21.3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-13",
    className: "st3",
    d: "M47.2,5.2l-0.4,19.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.149733, 0.022437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-14",
    className: "st3",
    d: "M55.8,2.9l-0.4,21.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-16",
    className: "st3",
    d: "M0,2l12.5-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-18",
    className: "st3",
    d: "M47.1,5.2l8.7-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-20",
    className: "st3",
    d: "M46.6,28.8l8.8-4.9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-23",
    className: "st3",
    d: "M43.3,5l3.9,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-24",
    className: "st3",
    d: "M46.8,24.7l-0.1,4.2"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000000192287094210756230000010063369191664214146_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.1,18.6c-0.4,0-0.7-0.2-0.8-0.6l0,0.4l-0.4,0l0.4-3.7l0.4,0l-0.1,1.5c0.2-0.3,0.6-0.4,0.9-0.4 c0.7,0.1,1.2,0.7,1.1,1.5S33.8,18.6,33.1,18.6z M33.3,16.3c-0.5,0-0.9,0.3-1,0.9s0.3,1,0.8,1s0.9-0.3,0.9-0.9S33.8,16.3,33.3,16.3 L33.3,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.2,18.9l-0.4,0l0-0.4c-0.2,0.3-0.6,0.4-0.9,0.4c-0.7-0.1-1.2-0.7-1.1-1.5c0.1-0.7,0.7-1.3,1.4-1.2 c0.3,0,0.7,0.2,0.8,0.5l0-0.4l0.4,0L37.2,18.9z M36.1,16.6c-0.5,0-0.9,0.3-0.9,0.9c-0.1,0.5,0.3,1,0.8,1c0.5,0,0.9-0.3,1-0.8 C36.9,17.1,36.6,16.6,36.1,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.9,19.1c-0.4,0-0.7-0.2-0.8-0.6l0,0.4l-0.4,0l0.4-3.7l0.4,0l-0.1,1.5c0.2-0.3,0.6-0.4,0.9-0.4 c0.7,0.1,1.2,0.7,1.1,1.5S39.6,19.2,38.9,19.1z M39.1,16.9c-0.5,0-0.9,0.3-1,0.9s0.3,1,0.8,1c0.5,0,0.9-0.3,0.9-0.9 S39.6,16.9,39.1,16.9L39.1,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.3,19.8c-0.2,0.5-0.5,0.6-1,0.5l0-0.4c0.3,0.1,0.5,0,0.6-0.3l0.2-0.3l-0.7-2.6l0.5,0l0.5,2.1l0.9-1.9l0.4,0 L41.3,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.8,16L7.2,16l0.1-1.5c0-0.1,0-0.5-0.4-0.5c-0.3,0-0.5,0.1-0.5,0.4c0,0,0,0,0,0l-0.1,1.5l-0.7-0.1l0.4-3.7 l0.7,0.1l-0.1,1.3c0.2-0.1,0.4-0.2,0.6-0.1c0.6,0.1,1,0.5,0.9,1.2L7.8,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.7,16.3l-0.6-0.1l0-0.3c-0.2,0.2-0.5,0.3-0.8,0.2c-0.7-0.1-1.1-0.7-1.1-1.4c0.1-0.7,0.7-1.3,1.3-1.2 c0.3,0,0.6,0.2,0.7,0.4l0-0.3l0.6,0.1L10.7,16.3z M9.6,14.2c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.7,0.6,0.8c0.4,0,0.7-0.3,0.7-0.7 C10.2,14.6,10,14.2,9.6,14.2L9.6,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.5,16.5c-0.3,0-0.5-0.2-0.7-0.4l-0.1,1.4L11,17.5l0.4-3.7l0.6,0.1l0,0.3c0.2-0.2,0.5-0.3,0.8-0.2 c0.7,0.1,1.1,0.7,1.1,1.4C13.8,16.1,13.2,16.6,12.5,16.5z M12.6,14.5c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.8,0.6,0.8 s0.7-0.2,0.7-0.7C13.2,14.9,13,14.5,12.6,14.5L12.6,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.4,16.8c-0.3,0-0.5-0.2-0.7-0.4l-0.1,1.4l-0.7-0.1l0.4-3.7l0.6,0.1l0,0.3c0.2-0.2,0.5-0.3,0.8-0.2 c0.7,0.1,1.1,0.7,1.1,1.4C16.7,16.4,16.1,16.9,15.4,16.8z M15.5,14.8c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.2,0.8,0.6,0.8 c0.4,0,0.7-0.2,0.7-0.7C16.2,15.1,15.9,14.8,15.5,14.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 15.4,
    transform: "matrix(9.746400e-02 -0.9952 0.9952 9.746400e-02 0.1238 31.5118)",
    className: "st4",
    width: 2.5,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.7,16.1c0,0.3,0.3,0.5,0.6,0.6c0.2,0,0.4-0.1,0.6-0.2l0.7,0.1c-0.2,0.5-0.7,0.8-1.3,0.7 c-0.7-0.1-1.3-0.7-1.2-1.5c0.1-0.7,0.7-1.3,1.5-1.2l0,0c0.7,0.1,1.3,0.7,1.1,1.7L18.7,16.1z M20.1,15.7c0-0.3-0.3-0.5-0.6-0.5 c-0.3,0-0.6,0.1-0.7,0.4L20.1,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22,17.5c-0.6-0.1-1.1-0.4-1.1-1l0.7,0.1c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.5,0,0.5-0.2s-0.1-0.2-0.5-0.3 c-0.4-0.1-1-0.3-1-0.9c0-0.4,0.4-0.8,1.2-0.7c0.6,0.1,1,0.4,1,0.9l-0.7-0.1c0-0.1-0.2-0.2-0.4-0.3c-0.3,0-0.4,0.1-0.4,0.2 c0,0.1,0.2,0.2,0.5,0.3c0.6,0.2,1.1,0.3,1,0.9C23.1,17.2,22.6,17.5,22,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.7,17.7c-0.8,0-1.1-0.5-1-1.2l0.1-0.9l-0.3,0l0.1-0.6l0.3,0l0.1-0.6l0.6,0.1l-0.1,0.6l0.5,0l-0.1,0.6 l-0.5,0l-0.1,0.9c0,0.4,0.1,0.5,0.4,0.5L24.7,17.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 17.6,
    cy: 13.6,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.2,14.2c-0.3,0-0.5,0.1-0.7,0.2c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0.1,0.1c0.1,0,0.4,0,0.6-0.1 c0.2-0.1,0.4-0.2,0.5-0.3C28.6,14.2,28.4,14.2,28.2,14.2L28.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31,16.2L31,16.2C31,16.2,31,16.2,31,16.2c-0.1-0.4-0.2-0.8-0.3-1.1c-0.2-0.4-0.5-0.8-1-1l-0.1,0 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0-0.1c-0.5-0.7-1.6-0.2-1.7-0.2c-0.1,0.1-0.2,0.2-0.2,0.4 c0,0,0,0.1,0.1,0.1l0,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.2,0.2-0.4,0.3-0.6,0.6c-0.2,0.4-0.4,0.7-0.4,1.6 c-0.1,0-0.2,0.1-0.2,0.2c-0.2,0.3-0.1,0.7,0,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2 c0.2,0.3,0.5,0.6,0.9,0.8c0.3,0.1,0.7,0.2,1,0.3c0.2,0,0.4,0,0.5,0l0,0c0.6,0,1.2-0.3,1.6-0.7c0.2-0.2,0.4-0.5,0.5-0.8 c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.2,0.3-0.4C31.4,16.7,31.3,16.4,31,16.2z M31.1,16.9c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2,0-0.3,0 c-0.1,0.3-0.2,0.6-0.5,0.9c-0.4,0.4-0.9,0.6-1.5,0.6l0,0l0,0c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6-0.1-1-0.2c-0.3-0.1-0.6-0.4-0.8-0.7 c-0.1-0.1-0.1-0.2-0.1-0.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.2-0.4,0-0.6c0.1-0.1,0.2-0.1,0.3-0.1 c0-0.9,0.2-1.2,0.4-1.6c0.1-0.2,0.3-0.4,0.5-0.5c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2c-0.2,0.1-0.3,0.3-0.5,0.5 c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.3-0.1,0.7-0.1,1c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.1,0.1,0,0.3,0,0.3l0,0 c0,0,0.1,0.1,0.3,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.4c0.2,0.3,0.4,0.5,0.7,0.6c0.8,0.3,2,0.4,2.7-0.3 c0.2-0.2,0.4-0.5,0.4-0.9c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.2,0.1,0.2,0c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2-0.1-0.3 c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0-0.1c0,0,0-0.8-0.2-1.1c-0.2-0.3-0.4-0.6-0.8-0.8l-0.1,0c-0.1-0.1-0.2-0.1-0.4-0.1l0,0 c0,0-0.1,0-0.2,0c0,0,0,0.1,0,0.1c-0.1,0.2-0.3,0.3-0.6,0.4c-0.3,0.1-0.6,0.2-0.7,0.1c-0.1,0-0.3-0.1-0.3-0.3c0-0.2,0-0.3,0.2-0.4 c0.2-0.2,0.7-0.3,1.2-0.3c-0.1-0.1-0.3-0.1-0.6-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.1,0-0.1,0-0.2-0.1c0-0.1,0-0.1,0.1-0.1 c0,0,1.1-0.4,1.4,0.1c0,0,0,0.1,0.1,0.1c0.1,0,0.2,0,0.2,0.1c0.1,0,0.3,0.1,0.4,0.2l0.1,0c0.4,0.2,0.7,0.5,0.9,0.9 c0.2,0.3,0.2,0.8,0.2,1.1c0,0,0.1,0,0.1,0C31.1,16.5,31.2,16.7,31.1,16.9L31.1,16.9z M27.3,16.3L27.3,16.3c0.1,0,0.2,0.1,0.3,0.1 c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0 c0,0,0,0-0.1,0c0,0,0-0.1,0-0.1C26.9,16.4,27.1,16.3,27.3,16.3L27.3,16.3z M28.5,17.5c0.3,0,0.5-0.3,0.6-0.3c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1l0,0c0,0,0,0,0,0c-0.1,0.2-0.2,0.6-0.6,0.6l0,0l0,0c-0.5,0-0.6-0.5-0.6-0.6c0,0,0-0.1,0-0.1l0,0c0,0,0.1,0,0.1,0 C28.1,17.4,28.2,17.5,28.5,17.5L28.5,17.5z M28.2,16.8c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.3,0.2c0,0,0,0.1-0.1,0.1 c0,0,0,0-0.1,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.1C28.3,16.9,28.2,16.9,28.2,16.8L28.2,16.8 C28.2,16.9,28.1,16.9,28.2,16.8z M29.2,16.4c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.4,0,0.5,0.3c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0l0,0 c0,0-0.1,0-0.1,0c-0.1-0.2-0.2-0.2-0.3-0.2c-0.1,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0C29.2,16.5,29.2,16.5,29.2,16.4 C29.2,16.4,29.2,16.4,29.2,16.4L29.2,16.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooBoxInactiveV2);
export default __webpack_public_path__ + "static/media/snoo-box-inactive_v2.15013fc4c741904f65879b6bb49a4896.svg";
export { ForwardRef as ReactComponent };